import React, { useState } from 'react';
import ReactTable, { ReactTableDefaults } from 'react-table-6';
import { CSVLink } from 'react-csv';
import { MdSync } from 'react-icons/md';
import '../../styles/4-components/_react-table.scss';
import './OrderListTable.scss';
import 'react-table-6/react-table.css';
import { useTableHeight } from 'hooks/useTableHeight';
import { ReqEnum } from 'const/requestStatus';
import { AvgTimeDeviations, RevenueKpi } from './utils/ReportUtils';
import { reactTableToDataDownload } from './utils/reactTableToDataDownload';
import { createBillingCompanyColumns } from './Columns/createBillingCompanyColumns';
import { ButtonComponent } from '../../ReusableComponents/Button/ButtonComponent';

const tableWrapper: any = React.createRef();
let reactTable: any = React.createRef();
let csvLink: any = React.createRef();

export function BillingCompanyListTable({
  orders,
  fetchStatus,
  csvName,
}: {
  orders: any[];
  fetchStatus: ReqEnum;
  csvName: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [dataToDownload, setDataToDownload] = useState([]);

  const [tableHeight] = useTableHeight(tableWrapper);
  const columns = createBillingCompanyColumns();

  const pagination = orders.length >= 100;

  const runDownload = async columns => {
    const data = reactTableToDataDownload(reactTable, columns);
    await setDataToDownload(data);
    if (data.length) {
      // click the CSVLink component to trigger the CSV download
      csvLink.link.click();
    }
  };

  if (orders.length === 0) {
    return <div style={{ marginLeft: '5px' }}> No Records </div>;
  }

  if (!isOpen) {
    return (
      <div>
        <ButtonComponent onClick={() => setIsOpen(!isOpen)}>
          Open
        </ButtonComponent>
      </div>
    );
  }

  if (isOpen) {
    return (
      <>
        <ButtonComponent onClick={() => setIsOpen(!isOpen)}>
          Close
        </ButtonComponent>
        <div
          className={
            fetchStatus === ReqEnum.PENDING
              ? 'orderlisttable is-loading'
              : 'orderlisttable'
          }
        >
          <div className="orderlisttable__header">
            <div className="orderlisttable__header__buttons u-screen-only">
              <ButtonComponent
                onClick={() => runDownload(columns)}
                disabled={orders.length === 0}
              >
                Download CSV
              </ButtonComponent>
              <CSVLink
                data={dataToDownload}
                filename={csvName}
                className="hidden"
                ref={r => (csvLink = r)}
                target="_blank"
              />
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-evenly',
              marginTop: '10px',
              marginBottom: '10px',
            }}
          >
            <RevenueKpi orders={orders} />
            <AvgTimeDeviations orders={orders} />
          </div>

          <div
            ref={tableWrapper}
            className="u-print-height-auto"
            style={{
              height: tableHeight,
            }}
          >
            <ReactTable
              ref={r => (reactTable = r)}
              data={orders}
              resizable={false}
              pageSize={pagination ? 100 : orders.length}
              showPagination={pagination}
              className="-striped -highlight"
              previousText="Forrige"
              nextText="Neste"
              loadingText="Henter ordre..."
              noDataText="Fant ingen ordre"
              pageText="Side"
              ofText="av"
              rowsText="ordre"
              // pageJumpText="gå til side"
              // rowsSelectorText="ordre per side"
              column={{
                ...ReactTableDefaults.column,
                minWidth: 0,
              }}
              columns={columns}
              defaultFilterMethod={(filter, row) =>
                String(row[filter.id]) === filter.value
              }
              filterable
            >
              {(state, makeTable, instance) => {
                let recordsInfoText = '';

                const { filtered, pageRows, pageSize, sortedData, page } =
                  state;

                if (sortedData && sortedData.length > 0) {
                  const isFiltered = filtered.length > 0;

                  const totalRecords = sortedData.length;

                  const recordsCountFrom = page * pageSize + 1;

                  const recordsCountTo = recordsCountFrom + pageRows.length - 1;

                  if (isFiltered)
                    recordsInfoText = `${recordsCountFrom}-${recordsCountTo} of ${totalRecords} filtered records`;
                  else
                    recordsInfoText = `${recordsCountFrom}-${recordsCountTo} of ${totalRecords} records`;
                } else recordsInfoText = 'No records';

                return (
                  <div className="main-grid">
                    <div className="above-table text-right">
                      <div className="col-sm-12">
                        <span className="records-info">{recordsInfoText}</span>
                      </div>
                    </div>

                    {makeTable()}
                  </div>
                );
              }}
            </ReactTable>
          </div>
          <div className="orderlisttable__spinner">
            <MdSync />
          </div>
        </div>
      </>
    );
  }
}
